<div class="header">
    <span class="header-name">{{ container.name }}</span>
    <div class="buttons-wrapper" *ngIf="isUserOwner">
        <div class="owner-buttons">
            <div
                class="button members-button"
                (mouseenter)="hoveredFunctionalButtonIdx = 0"
                (mouseleave)="hoveredFunctionalButtonIdx = -1"
                (click)="openMembers()"
                (keydown.enter)="openMembers()"
                tabindex="0"
            >
                <img
                    class="members-svg"
                    [src]="
                        'assets/svg/reusable-svg/members' +
                        (hoveredFunctionalButtonIdx === 0 ? '-hover' : '') +
                        '.svg'
                    "
                    alt="members-icon"
                />
                <div
                    class="tryb-notification-icon-wrapper"
                    *ngIf="areRequestsExisting()"
                >
                    <img
                        class="notification-icon"
                        src="assets/svg/reusable-svg/notification.svg"
                        alt="notification-icon"
                    />
                </div>
            </div>
            <div
                class="button settings-button"
                (mouseenter)="hoveredFunctionalButtonIdx = 1"
                (mouseleave)="hoveredFunctionalButtonIdx = -1"
                (click)="openSettings()"
                (keydown.enter)="openSettings()"
                tabindex="0"
            >
                <img
                    class="settings-svg"
                    [src]="
                        'assets/svg/reusable-svg/settings' +
                        (hoveredFunctionalButtonIdx === 1 ? '-hover' : '') +
                        '.svg'
                    "
                    alt="settings-icon"
                />
            </div>
        </div>
        <div
            class="button create-project-button"
            (click)="onOpenCreationWizard()"
            (keydown.enter)="onOpenCreationWizard()"
            tabindex="0"
            [title]="
                'imgDb.header.functionalButtons.createProject.tooltip'
                    | translate
            "
        >
            {{
                'imgDb.header.functionalButtons.createProject.buttonText'
                    | translate
            }}
        </div>
    </div>
</div>
